import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Baoming = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 20 20"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="c73cc__a">
              <rect
                rx="0"
                height="20"
                width="20"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#c73cc__a)">
            <path
              fill="#1D9D94"
              d="M2.083 2.917c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v15.416H3.333c-.69 0-1.25-.56-1.25-1.25V2.917Z"
            />
            <path
              fill="#1D9D94"
              fillRule="evenodd"
              d="M1.458 2.917v14.166q0 .777.55 1.326.549.55 1.325.55h11.25c.346 0 .625-.28.625-.626V2.917q0-.777-.549-1.326-.549-.55-1.326-.55h-10q-.776 0-1.325.55-.55.549-.55 1.326Zm1.433 14.608q-.183-.183-.183-.442V2.917q0-.26.183-.442.183-.183.442-.183h10q.26 0 .442.183.183.183.183.442v14.791H3.333q-.259 0-.442-.183Z"
            />
            <path
              fill="#1D9D94"
              fillRule="evenodd"
              d="M13.958 10v8.333c0 .345.28.625.625.625h2.084q.776 0 1.326-.549.549-.549.549-1.326V10q0-.604-.427-1.031-.428-.427-1.032-.427h-1.666q-.604 0-1.031.427-.428.427-.428 1.031Zm1.25 7.708h1.459q.259 0 .442-.183t.183-.442V10q0-.208-.209-.208h-1.666q-.087 0-.148.06-.06.062-.06.148v7.708Z"
            />
            <path
              fill="#E8FFFA"
              fillRule="evenodd"
              d="M4.583 5.625h3.334a.625.625 0 1 0 0-1.25H4.583a.625.625 0 1 0 0 1.25Zm0 2.917h5a.625.625 0 1 0 0-1.25h-5a.625.625 0 1 0 0 1.25Z"
            />
          </g>
        </g>
      </svg>
    )
  }
)
